import { GroupType } from "./GroupType.d";


import {ID, ListRequest} from "../../../types/global.d";
import {displayTime, displayDate, displayDateTime} from "../../../utils/formatDate";
import {OrderBy} from "../../../types/global.d";

// Interface for entity MembersGroups


export interface MembersGroup {
    id: ID;

    
    name: string;

    
    hierarchyName: string;

    
    description?: string;

    
    groupType: GroupType;

    
    parentId?: ID;

    }

export interface FilterAdvancedPresentationRequest {
    list: ListRequest,
    filter: {
        
            name?: string,
        
    
    

            hierarchyName?: string,
        
    
    

            groupType?: GroupType,
        
    
    

            parentId: ID[],
        
    
    parentIdInclude: boolean,



        parentIdRefs?: ID[],
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}



export interface CreateMembersGroup {
    
    name: string;

    
    
    description?: string;

    
    groupType: GroupType;

    
    parentId?: ID;

    }


export interface UpdateMembersGroup {
    
    name: string;

    
    
    description?: string;

    
    
    }

export interface PresentationMembersGroupRequest {
    list: ListRequest,
    filter: {
        hierarchyName: string,
        hierarchyNameOr: boolean,
        parentIdRefs?: ID[],
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}

export class PrimaryMembersGroup {
    id: string;


    constructor(
        id: ID,
        ) {
        this.id = id?.toString();
        }

    static fromEntity(entity: MembersGroup): PrimaryMembersGroup | undefined {
        return entity ? new PrimaryMembersGroup(
            entity.id,
        ) : undefined;
    }

    static fromId(id: ID
): PrimaryMembersGroup {
        return new PrimaryMembersGroup(
                id,
                );
    }
    
    static fromPath(path?: string): PrimaryMembersGroup {
        let vals = path?.split('/');
        return new PrimaryMembersGroup(
                   vals[0],
                );
    }

    static fromQuery(value?: string): number | undefined {
        return value ? value : undefined
    }

    toPath(): string {
        let ids = [
            this.id,
            ];
        return ids.join('/');
    }

    static toQueryParams(ids: PrimaryMembersGroup[]): string {
        return '?ids=' + ids.map(id => id.id).join('&ids=');
    }
}

export function toString(entity?: MembersGroup): string {
    let fields = entity ? [
    entity.hierarchyName,
            ] : [];
    return fields.filter(item => item).join(' | ');
}

export class UpdateEntityMembersGroup {
    id: PrimaryMembersGroup;
    data: UpdateMembersGroup;


    constructor(id: PrimaryMembersGroup, data: UpdateMembersGroup) {
        this.id = id;
        this.data = data;
    }
}
